///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { Directive, HostBinding } from '@angular/core';

@Directive({
    selector: 'sui-svg-icon[windeGrey]',
    standalone: false
})
export class GreyActionIconDirective {
    @HostBinding('class') buttonClass = 'winde-svg-action-icon';

    @HostBinding('style.width') width = '1em';
    @HostBinding('style.height') height = '1em';
}
